(function() {
    'use strict';

    angular.module('app.unidades', []);
})();
